import { types } from 'mobx-state-tree';


const GARAGE_TYPES = {
    ATTACHED: 'attached',
    DETACHED: 'detached',
    BUILT_IN: 'built-in',
    BASEMENT: 'basement',
};

const GarageTypeEnum = types.enumeration('GarageType', Object.values(GARAGE_TYPES));

export {
    GarageTypeEnum,
};
export default GARAGE_TYPES;
